/** @jsxImportSource @emotion/react */

import AboutUsBlock from "./AboutUsBlock";
import { FooterStyle } from "./index.style";
import InfoBlock from "./InfoBlock";
import ShBlock from "./ShBlock";
import SupplierBlock from "./SupplierBlock";

const Footer = () => {
  return (
    <footer css={FooterStyle.self}>
      <div css={FooterStyle.wrapper}>
        <div css={FooterStyle.infoBlock}>
          <InfoBlock />
        </div>
        <div css={FooterStyle.shBlock}>
          <ShBlock />
        </div>
        <div css={FooterStyle.aboutUsBlock}>
          <AboutUsBlock />
        </div>
      </div>
      <div css={FooterStyle.supplierWrap}>
        <SupplierBlock />
      </div>
    </footer>
  );
};

export default Footer;
